import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { LMListBlockGridBaseDirective } from '@list/lm-list-blockgrid-base.directive';
import {
  LMBusyIndicatorService,
  LMContextService, LMErrorUtilService,
  LMFormatUtilService,
  LMLoggerService, LMUrlUtilService,
} from '@app/services';
import { LMThemeService } from '@banner/lm-theme.service';
import { LMListEventService, LMListGridPagingService, LMListSpecUtilService, LMListUtilService } from '@list/services';
import { LMHorizontalScrollerComponent } from '@app/components';

@Component({
  selector: 'lm-list-gallery',
  templateUrl: './lm-list-gallery.component.html',
  styleUrls: [ 'lm-list-gallery.component.scss' ]
})
export class LMListGalleryComponent extends LMListBlockGridBaseDirective implements OnInit {
  public selected = false;
  public isHorizontal: boolean;

  @ViewChild('HorizontalScroller') horizontalScroller: LMHorizontalScrollerComponent;

  constructor(
    protected lmContextService: LMContextService,
    protected lmLoggerService: LMLoggerService,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmThemeService: LMThemeService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected lmErrorUtilService: LMErrorUtilService,
    protected lmListEventService: LMListEventService,
    protected lmListGridPagingService: LMListGridPagingService,
    protected lmListSpecUtilService: LMListSpecUtilService,
    protected lmListUtilService: LMListUtilService,
    protected lmUrlUtilService: LMUrlUtilService
  ) {
    super(
      lmContextService,
      lmLoggerService,
      lmFormatUtilService,
      lmThemeService,
      lmBusyIndicatorService,
      changeDetectorRef,
      lmErrorUtilService,
      lmListEventService,
      lmListGridPagingService,
      lmListSpecUtilService,
      lmListUtilService,
      lmUrlUtilService
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.isHorizontal = this.implementsHorizontal();
  }

  public isModified(): boolean {
    return false;
  }

  public scrollIsStart() {
    return this.horizontalScroller?.scrollIsStart;
  }

  public async scrollIsStartPromise(): Promise<boolean> {
    return await this.horizontalScroller?.scrollIsStartPromise();
  }

  public async scrollIsEndPromise(): Promise<boolean> {
    return await this.horizontalScroller?.scrollIsEndPromise();
  }

  public scrollIsEnd() {
    return this.horizontalScroller?.scrollIsEnd;
  }

  public scrollNext() {
    this.horizontalScroller?.scrollNext();
  }

  public scrollPrevious() {
    this.horizontalScroller?.scrollPrevious();
  }

  public hasOverflow() {
    this.horizontalScroller?.hasOverflow();
  }

  private implementsHorizontal(): boolean {
    return this.lmListSpecUtilService.allowHorizontalPaging(this.listSpec);
  }
}
